import { Stack, Typography } from "@mui/material";
import { MATCH_BASIS_LABELS, MATCH_BASIS_ORDER } from "../../constants";
import { MatchBasisMark } from "./MatchBasisMark";

interface Props {
  /** 文字の色。ツールチップの中では inherit にする */
  color?: string;
  /** 凡例の後ろ（右端）に置く要素（出典へのリンクなど） */
  trailing?: React.ReactNode;
}

/**
 * 紐付けの方法のマークの凡例（薄い文字の1行）
 * @param props.color 文字の色
 * @param props.trailing 右端に置く要素
 * @returns 凡例
 */
export const MatchBasisLegend: React.FC<Props> = ({
  color = "text.secondary",
  trailing,
}) => (
  <Stack
    direction="row"
    flexWrap="wrap"
    useFlexGap
    alignItems="center"
    columnGap={2}
    rowGap={0.5}
    sx={{ color }}
  >
    {MATCH_BASIS_ORDER.map((basis) => (
      <Stack key={basis} direction="row" spacing={0.5} alignItems="center">
        <MatchBasisMark basis={basis} />
        <Typography variant="caption">{MATCH_BASIS_LABELS[basis]}</Typography>
      </Stack>
    ))}
    {trailing ? <span style={{ marginLeft: "auto" }}>{trailing}</span> : null}
  </Stack>
);
